<template>
  <DetailSection
    title="License Number"
    :editable="editable"
    :commit="commit"
    @edit="beginEditing"
    @cancel="cancel"
  >
    <template #default="{ isEditing, isSaving }">
      <div class="section-content">
        <div v-if="!isEditing" class="font-monospace text-uppercase">
          {{ license.number ?? license.id }}
        </div>
        <template v-else>
          <input
            ref="input"
            v-model="draftLicenseId"
            type="text"
            class="form-control form-control-sm"
            autocomplete="off"
            :disabled="isSaving"
          />
          <div v-if="error" class="small text-danger" role="alert">
            {{ error.message || String(error) }}
          </div>
        </template>
      </div>
    </template>
  </DetailSection>
</template>

<script>
import DetailSection from '@/components/common/DetailSection.vue';
import { License } from '@/models/License';

export default {
  components: { DetailSection },
  props: {
    license: {
      type: License,
      required: true
    },
    editable: Boolean
  },
  data() {
    return {
      draftLicenseId: '',
      error: null
    };
  },
  watch: {
    license: {
      immediate: true,
      handler() {
        this.resetDraft();
      }
    }
  },
  methods: {
    resetDraft() {
      this.draftLicenseId = this.license?.number || this.license?.id || '';
    },
    beginEditing() {
      this.error = null;
      this.resetDraft();
      this.$nextTick(() => {
        this.$refs.input?.focus();
        this.$refs.input?.select();
      });
    },
    cancel() {
      this.error = null;
      this.resetDraft();
    },
    async commit(note) {
      this.error = null;
      const licenseId = String(this.draftLicenseId || '').trim();

      try {
        if (!licenseId) {
          throw new Error('License ID is required');
        }
        if (licenseId === this.license.number) {
          return;
        }
        await this.license.updateLicenseId(licenseId, note);
        this.resetDraft();
      } catch (error) {
        this.error = error;
        throw error;
      }
    }
  }
};
</script>
